import { Link } from "react-router-dom";

const TermsSection = ({ number, title, children }) => (
  <section aria-labelledby={`terms-section-${number}`} className="border-t border-[#0E1B31]/10 pt-9 sm:pt-11">
    <h2 id={`terms-section-${number}`} className="font-display text-2xl sm:text-3xl font-semibold leading-snug text-[#0E1B31]">
      {number}. {title}
    </h2>
    <div className="mt-5 space-y-4 text-[15px] sm:text-base leading-[1.8] text-[#3B4A5E]">{children}</div>
  </section>
);

const LegalLink = ({ to, children }) => (
  <Link className="underline underline-offset-4 hover:text-[#0E1B31]" to={to}>{children}</Link>
);

export default function Terms() {
  return (
    <div data-testid="terms-page">
      <header className="relative overflow-hidden mesh-hero grain pt-36 pb-16 lg:pt-44 lg:pb-20">
        <div className="perspective-grid" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="font-mono-brand text-[11px] tracking-[0.28em] uppercase text-[#2C4A6F]">ΟΡΟΙ ΧΡΗΣΗΣ</p>
          <h1 className="mt-7 font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight leading-[1.06] text-[#0E1B31]">Όροι Χρήσης</h1>
          <p className="mt-6 text-sm sm:text-base text-[#3B4A5E]">Τελευταία ενημέρωση: 11 Οκτωβρίου 2026</p>
        </div>
      </header>

      <article className="max-w-3xl mx-auto px-4 sm:px-6 py-16 sm:py-20 lg:py-24 space-y-11 sm:space-y-14" aria-label="Όροι Χρήσης CRESTIA">
        <div className="space-y-5 text-[15px] sm:text-base leading-[1.8] text-[#3B4A5E]">
          <p>Οι παρόντες Όροι Χρήσης διέπουν την πρόσβαση και τη χρήση του ιστοτόπου της CRESTIA. Παρακαλούμε να τους διαβάσετε πριν χρησιμοποιήσετε το περιεχόμενο ή τις διαδραστικές λειτουργίες του.</p>
        </div>

        <TermsSection number="1" title="Αντικείμενο και αποδοχή των όρων">
          <p>Με την πρόσβαση στον ιστότοπο αποδέχεστε τους παρόντες όρους, στον βαθμό που επιτρέπεται από την εφαρμοστέα νομοθεσία. Αν δεν συμφωνείτε, μπορείτε να μη χρησιμοποιήσετε τον ιστότοπο.</p>
          <p>Η επίσκεψη στον ιστότοπο ή η αποστολή ενός αιτήματος δεν δημιουργεί από μόνη της σύμβαση παροχής υπηρεσιών με την CRESTIA. Κάθε ενδεχόμενη συνεργασία συμφωνείται ξεχωριστά.</p>
        </TermsSection>

        <TermsSection number="2" title="Χρήση του ιστοτόπου">
          <p>Ο ιστότοπος προορίζεται για νόμιμη ενημέρωση και επικοινωνία σχετικά με την CRESTIA και τις υπηρεσίες της. Ο χρήστης οφείλει να παρέχει ακριβή στοιχεία όταν επιλέγει να υποβάλει φόρμα ή αίτημα και να χρησιμοποιεί τις λειτουργίες χωρίς να επηρεάζει την ασφάλεια ή τη διαθεσιμότητά τους.</p>
        </TermsSection>

        <TermsSection number="3" title="Υπηρεσίες και πληροφοριακό περιεχόμενο">
          <p>Οι περιγραφές υπηρεσιών παρουσιάζουν ενδεικτικά τους τομείς στους οποίους δραστηριοποιείται η CRESTIA. Δεν αποτελούν εξατομικευμένη πρόταση, εγγύηση συγκεκριμένου αποτελέσματος ή δέσμευση ότι κάθε υπηρεσία είναι κατάλληλη για κάθε επιχείρηση.</p>
          <p>Το αντικείμενο, η διάρκεια και οι όροι μιας συνεργασίας καθορίζονται μόνο μετά από σχετική συνεννόηση.</p>
        </TermsSection>

        <TermsSection number="4" title="Άρθρα και ενημερωτικό περιεχόμενο">
          <p>Τα άρθρα, οι αναλύσεις και λοιπό υλικό εκφράζουν γενικές πληροφορίες και εκτιμήσεις κατά τον χρόνο δημοσίευσής τους. Μπορεί να χρειάζονται επικαιροποίηση όταν μεταβάλλονται οι αγορές, η τεχνολογία ή οι συνθήκες μιας επιχείρησης.</p>
          <p>Παρακαλούμε να αξιολογείτε την εφαρμογή οποιασδήποτε ιδέας στα δικά σας δεδομένα πριν λάβετε απόφαση.</p>
        </TermsSection>

        <TermsSection number="5" title="AI και διαδραστικές λειτουργίες">
          <p>Ο ιστότοπος μπορεί να παρέχει λειτουργίες τεχνητής νοημοσύνης, όπως ψηφιακό βοηθό και ενδεικτική αξιολόγηση επιχειρηματικών ευκαιριών. Οι απαντήσεις παράγονται αυτόματα, ενδέχεται να είναι ελλιπείς ή ανακριβείς και έχουν μόνο ενημερωτικό χαρακτήρα.</p>
          <p>Πριν από σημαντική επιχειρηματική απόφαση, ελέγχετε ανεξάρτητα τα δεδομένα και τα συμπεράσματα. Μην εισάγετε ευαίσθητα ή περιττά εμπιστευτικά δεδομένα, ούτε στοιχεία τρίτων χωρίς νόμιμη βάση. Περισσότερα για την επεξεργασία δεδομένων αναφέρονται στην <LegalLink to="/privacy-policy">Πολιτική Απορρήτου</LegalLink>.</p>
        </TermsSection>

        <TermsSection number="6" title="Περιορισμός επαγγελματικής συμβουλής">
          <p>Το περιεχόμενο του ιστοτόπου και τα αποτελέσματα των διαδραστικών εργαλείων δεν συνιστούν αυτομάτως εξατομικευμένη νομική, χρηματοοικονομική, φορολογική ή επενδυτική συμβουλή, ούτε δεσμευτική επιχειρηματική συμβουλή.</p>
          <p>Για αποφάσεις με σημαντικές συνέπειες, ζητήστε κατάλληλη εξατομικευμένη αξιολόγηση από αρμόδιο επαγγελματία.</p>
        </TermsSection>

        <TermsSection number="7" title="Ακρίβεια και διαθεσιμότητα πληροφοριών">
          <p>Η CRESTIA καταβάλλει προσπάθεια για την ορθή παρουσίαση και λειτουργία του ιστοτόπου, χωρίς να μπορεί να εγγυηθεί ότι κάθε πληροφορία θα είναι διαρκώς πλήρης ή ενημερωμένη ή ότι η πρόσβαση θα είναι αδιάλειπτη.</p>
          <p>Μπορεί να γίνονται διορθώσεις, συντηρήσεις ή προσωρινές διακοπές όταν είναι αναγκαίο.</p>
        </TermsSection>

        <TermsSection number="8" title="Πνευματική ιδιοκτησία">
          <p>Το κείμενο, ο σχεδιασμός, τα σήματα, οι εικόνες και το λοιπό περιεχόμενο του ιστοτόπου προστατεύονται σύμφωνα με την εφαρμοστέα νομοθεσία και τα δικαιώματα των αντίστοιχων δικαιούχων.</p>
          <p>Επιτρέπεται η προσωπική χρήση και η νόμιμη παραπομπή στον ιστότοπο. Η περαιτέρω αναπαραγωγή ή εμπορική εκμετάλλευση απαιτεί την άδεια του δικαιούχου, εκτός αν επιτρέπεται ρητά από τον νόμο.</p>
        </TermsSection>

        <TermsSection number="9" title="Απαγορευμένη χρήση">
          <p>Δεν επιτρέπεται η χρήση του ιστοτόπου για παράνομο περιεχόμενο, παραπλανητικά αιτήματα, προσπάθεια μη εξουσιοδοτημένης πρόσβασης, εισαγωγή κακόβουλου λογισμικού ή ενέργειες που επιβαρύνουν δυσανάλογα την υποδομή του.</p>
          <p>Η παρούσα διάταξη δεν περιορίζει δικαιώματα που παρέχονται υποχρεωτικά από την ισχύουσα νομοθεσία.</p>
        </TermsSection>

        <TermsSection number="10" title="Σύνδεσμοι και υπηρεσίες τρίτων">
          <p>Ο ιστότοπος μπορεί να περιλαμβάνει συνδέσμους ή τεχνολογικές υπηρεσίες τρίτων. Η πρόσβαση σε εξωτερικό ιστότοπο διέπεται από τους δικούς του όρους και πρακτικές απορρήτου.</p>
          <p>Για πληροφορίες σχετικά με την επεξεργασία δεδομένων μέσω του παρόντος ιστοτόπου, ανατρέξτε στην <LegalLink to="/privacy-policy">Πολιτική Απορρήτου</LegalLink>.</p>
        </TermsSection>

        <TermsSection number="11" title="Περιορισμός ευθύνης">
          <p>Στον βαθμό που επιτρέπεται από την εφαρμοστέα νομοθεσία, η CRESTIA δεν ευθύνεται για αποφάσεις που λαμβάνονται αποκλειστικά με βάση γενικό περιεχόμενο ή μη επαληθευμένες απαντήσεις AI, ούτε για προσωρινή μη διαθεσιμότητα του ιστοτόπου εκτός του εύλογου ελέγχου της.</p>
          <p>Καμία διάταξη των παρόντων όρων δεν αποκλείει ή περιορίζει ευθύνη ή δικαιώματα που δεν μπορούν νόμιμα να αποκλειστούν ή να περιοριστούν.</p>
        </TermsSection>

        <TermsSection number="12" title="Αλλαγές στον ιστότοπο και στους όρους">
          <p>Η CRESTIA μπορεί να επικαιροποιεί τον ιστότοπο και τους παρόντες όρους όταν μεταβάλλονται οι υπηρεσίες, οι λειτουργίες ή οι νομικές απαιτήσεις. Η ισχύουσα έκδοση δημοσιεύεται στη σελίδα αυτή με ημερομηνία τελευταίας ενημέρωσης.</p>
        </TermsSection>

        <TermsSection number="13" title="Εφαρμοστέο δίκαιο">
          <p>Οι παρόντες όροι διέπονται από το ελληνικό δίκαιο, με την επιφύλαξη τυχόν υποχρεωτικών κανόνων προστασίας που εφαρμόζονται στον χρήστη. Οποιαδήποτε διαφορά εξετάζεται σύμφωνα με τους ισχύοντες κανόνες αρμοδιότητας.</p>
        </TermsSection>

        <TermsSection number="14" title="Επικοινωνία">
          <p>Για ερωτήσεις σχετικά με τον ιστότοπο ή τους παρόντες όρους, μπορείτε να επικοινωνήσετε με την CRESTIA μέσω της σελίδας <LegalLink to="/contact">Επικοινωνία</LegalLink>.</p>
        </TermsSection>
      </article>
    </div>
  );
}
